import { render, staticRenderFns } from "./BaseInfo.vue?vue&type=template&id=32eb94df"
import script from "./BaseInfo.vue?vue&type=script&lang=js"
export * from "./BaseInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseInfo.vue?vue&type=style&index=0&id=32eb94df&prod&lang=scss"
import style1 from "./BaseInfo.vue?vue&type=style&index=1&id=32eb94df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports